import { createFileRoute } from '@tanstack/react-router';

import { EditPost } from '#modules/finder/features/posts/components/EditPost';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/posts/$postId/edit'
)({
  component: EditPost,
  ssr: false,
});
